module.exports = constructor;
module.exports.Converter = require("./Converter.js");

function constructor(param,options) {
  return new module.exports.Converter(param, options);
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/csvtojson/libs/core/index.js
// module id = 239
// module chunks = 0